import { UISref } from "@uirouter/react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { PrimaryButton } from "../../../../components/button";
import { NoElements } from "../../../../components/no-elements";
import { BillingRoutes } from "../../routes";

const CTA = styled(PrimaryButton)`
  width: 20em;
`;

export const NoTransactions = () => {
  const { t } = useTranslation("billing");
  return (
    <NoElements item={t('transactions')}>
      <UISref to={BillingRoutes.names.purchase}>
        <a>
          <CTA variant="contained">{t("make-a-purchase")}</CTA>
        </a>
      </UISref>
    </NoElements>
  );
};
